module.exports = __webpack_public_path__ + "static/media/treasureHuntChestOpen.3fec1635.svg";